import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const FeaturesSection = () => {
  const features = [
    {
      icon: "bi-headset text-info",
      title: "Proven Live Support",
      description:
        "Our dedicated team is available 24/7 to assist you at every step of your journey.",
    },
    {
      icon: "bi-currency-dollar text-warning",
      title: "Lowest Price Guarantee",
      description:
        "Enjoy budget-friendly airfare deals for destinations around the world without overspending.",
    },
    {
      icon: "bi-check-circle text-primary",
      title: "Extra-Reliable and Trusted",
      description:
        "Get instant, top-quality service that ensures the best value for your money.",
    },
    
  ];
  

  return (
    <Container className="py-5">
      <Row className="text-center">
        {features.map((feature, index) => (
          <Col md={4} key={index} className="mb-4">
            <div className="d-flex flex-column align-items-center">
              <i className={`bi ${feature.icon} fs-2`}></i>
              <h5 className="mt-3 fw-bold">{feature.title}</h5>
              <p className="text-muted">{feature.description}</p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default FeaturesSection;
